"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNewPosts = exports.addNewFeed = void 0;
var lodash_1 = require("lodash");
var setIds = function (coll) { return coll.map(function (item) { return (__assign(__assign({}, item), { id: (0, lodash_1.uniqueId)() })); }); };
var getNewData = function (dataBefore, dataAfter, comparableKey) {
    var filtered = dataBefore
        .filter(function (item) { return !dataAfter.some(function (el) { return el[comparableKey] === item[comparableKey]; }); });
    var newData = setIds(filtered);
    return newData;
};
var addNewFeed = function (parsedData, state, link) {
    var getFeed = function () { return (__assign(__assign({}, parsedData.feed), { link: link, id: (0, lodash_1.uniqueId)() })); };
    var newFeed = getFeed();
    var newPosts = setIds(parsedData.posts);
    var feeds = [newFeed].concat(state.feeds);
    var posts = newPosts.concat(state.posts);
    return { feeds: feeds, posts: posts };
};
exports.addNewFeed = addNewFeed;
var getNewPosts = function (parsedPosts, statePosts) { return getNewData(parsedPosts, statePosts, 'link'); };
exports.getNewPosts = getNewPosts;
